import { NetworkActionPrefix, ActionType } from '../utils/constants';
import { MarketFeedBingCognitiveApi, MarketFeedBingCognitive } from 'for-straction-service-api'
import { networkAPIAction, entityLifecycleActionSet } from '../utils/actionCreatorsFactory';

const marketFeedBingCognitiveActionSet = entityLifecycleActionSet('MarketFeedBingCognitive', 'MARKET_FEED_BING_COGNITIVE', 'marketFeedBingCognitive', MarketFeedBingCognitiveApi, {
    loadAll: true,
    add: true,
    edit: true,
    delete: true
}, true);

export const loadAllMarketFeedBingCognitives = () => marketFeedBingCognitiveActionSet.loadAllMarketFeedBingCognitives();
export const addMarketFeedBingCognitive = (marketFeedBingCognitive, sync) => marketFeedBingCognitiveActionSet.addMarketFeedBingCognitive(marketFeedBingCognitive, sync);
export const editMarketFeedBingCognitive = (marketFeedBingCognitive, sync) => marketFeedBingCognitiveActionSet.editMarketFeedBingCognitive(marketFeedBingCognitive, sync);
export const removeMarketFeedBingCognitive = (marketFeedBingCognitive) => marketFeedBingCognitiveActionSet.removeMarketFeedBingCognitive(marketFeedBingCognitive);

export const addAllMarketFeedBingCognitives = (marketFeedBingCognitives) =>
    dispatch => {
        dispatch({
            type: ActionType.ADD_ALL_MARKET_FEED_BING_COGNITIVES,
            marketFeedBingCognitives
        });

        return dispatch(
            networkAPIAction(MarketFeedBingCognitiveApi, 'marketFeedBingCognitiveAddAllPut', NetworkActionPrefix.ADD_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX,
                { marketFeedBingCognitives }, marketFeedBingCognitives)
        );
    };

export const editAllMarketFeedBingCognitives = (marketFeedBingCognitives) =>
    dispatch => {
        dispatch({
            type: ActionType.EDIT_ALL_MARKET_FEED_BING_COGNITIVES,
            marketFeedBingCognitives
        });

        dispatch(
            networkAPIAction(new MarketFeedBingCognitiveApi(), 'marketFeedBingCognitiveEditAllPut', NetworkActionPrefix.EDIT_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX,
                { marketFeedBingCognitives }, marketFeedBingCognitives)
        );
    };

export const deleteAllMarketFeedBingCognitives = (marketFeedBingCognitiveIDs) =>
    dispatch => {
        dispatch({
            type: ActionType.DELETE_ALL_MARKET_FEED_BING_COGNITIVES,
            marketFeedBingCognitiveIDs
        });

        dispatch(
            networkAPIAction(new MarketFeedBingCognitiveApi(), 'marketFeedBingCognitiveDeleteAllPut', NetworkActionPrefix.DELETE_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX,
                { marketFeedBingCognitiveIDs }, marketFeedBingCognitiveIDs)
        );
    };

export const getSearchResultsFromBing = (searchKey, keywords, searchType, market, freshness) =>
    networkAPIAction(MarketFeedBingCognitiveApi, 'marketFeedBingCognitiveGetSearchResultsFromBingGet', NetworkActionPrefix.GET_SEARCH_RESULTS_FROM_BING_PREFIX,
        { searchKey }, keywords, searchType, { market, freshness });

export const dropSearchResultsFromBing = (searchKey) => {
    return {
        type: ActionType.DROP_SEARCH_RESULTS_FROM_BING,
        searchKey
    }
};